export const jurylijst = {
  back: "Terug naar de baan",
  ploegen: "Ploegen",
  progress: "{{answered}}/{{count}}",
  stand: {
    total: "Totaal {{total}}",
    rank: "{{rank}}e",
    rankLabel: "Plaats {{rank}} van {{of}}",
    noRank: "Nog geen plaats",
    functiePlaats: "{{name}}: {{plaats}}",
    /** One functie's line when a page shows several; `plaats` is rankLabel or noRank. */
    functie: "{{name}}: Totaal {{total}}, {{plaats}}",
  },
  drawer: {
    title: "Ploegen en totaal",
    choose: "Kies een ploeg",
  },
  choosePloeg: "Kies een ploeg om de vragen te beantwoorden.",
  openShort_one: "nog 1 vraag open",
  openShort_other: "nog {{count}} vragen open",
  lockedShort: "Vergrendeld",
  locked: "Deze ploeg is vergrendeld. Je kunt je antwoorden bekijken, maar niet meer aanpassen.",
  unknown: "Deze jurylijst staat niet op dit apparaat.",
  namens: "Je vult in namens {{name}}.",
  yes: "Ja",
  no: "Nee",
  cleared: "Gewist",
  clear: {
    menu: "Antwoord of opmerking wissen",
    answer: "Antwoord wissen",
    opmerking: "Alleen opmerking wissen",
    both: "Antwoord en opmerking wissen",
    opmerkingOnly: "Opmerking wissen",
    done: "Gewist.",
    undo: "Ongedaan maken",
  },
  time: {
    label: "Tijd als minuten:seconden",
    placeholder: "mm:ss",
    invalid: "Vul de tijd in als minuten:seconden, bijvoorbeeld 3:25 of 325.",
    save: "Tijd opslaan",
  },
  opmerking: {
    label: "Opmerking",
    add: "Opmerking toevoegen",
    save: "Opmerking opslaan",
    firstAnswer: "Kies eerst een antwoord.",
    kept: "Deze opmerking blijft bewaard voor je volgende antwoord.",
    required: "Bij een O of K is een opmerking verplicht. Zonder opmerking wordt het antwoord niet verstuurd.",
  },
  notitie: {
    label: "Notitie bij {{ploeg}}",
    open: "Schrijf een notitie",
    openWritten: "Open de notitie",
    hint: "Schrijf snel op wat je opvalt. De notitie wordt niet doorgestuurd naar VBS.",
  },
  state: {
    draft: "Wacht op opmerking",
    pending: "Nog niet verstuurd",
    rejected: "Geweigerd",
    synced: "Verstuurd",
    vbs: "Ingevuld in VBS",
  },
  /** Indexed by the Api's `RejectionReason`, which it serialises as an integer. */
  rejected: {
    "0": "Niet verstuurd: deze ploeg bestaat niet meer op de baan.",
    "1": "Niet verstuurd: deze vraag bestaat niet meer.",
    "2": "Niet verstuurd: je bent niet meer ingedeeld op deze functie.",
    "3": "Niet verstuurd: dit antwoord is bij deze vraag niet toegestaan.",
    "4": "Niet verstuurd: bij een O of K is een opmerking verplicht.",
    "5": "Niet verstuurd: dit antwoord botst met een ander antwoord. Kies het antwoord opnieuw.",
    "6": "Niet verstuurd: de klok van dit apparaat loopt voor. Zet de klok goed en kies het antwoord opnieuw.",
    "7": "Niet verstuurd: deze ploeg of baan is vergrendeld.",
  },
  total: {
    title: "Lijsttotaal: {{total}}",
    guide: "Alleen een richtlijn. VBS berekent de score.",
    answered: "{{answered}} van {{of}} ingevuld",
    answeredMissing_one: "{{answered}} van {{of}} ingevuld, 1 opmerking ontbreekt",
    answeredMissing_other: "{{answered}} van {{of}} ingevuld, {{count}} opmerkingen ontbreken",
    points_one: "punt",
    points_other: "punten",
    answeredOpen_one: "{{answered}} van {{of}} ingevuld, nog 1 vraag open",
    answeredOpen_other: "{{answered}} van {{of}} ingevuld, nog {{count}} vragen open",
    onlyOpen: "Alleen open vragen",
    noneOpen: "Er zijn geen open vragen meer.",
    missing_one: "1 opmerking ontbreekt",
    missing_other: "{{count}} opmerkingen ontbreken",
    collapseAll: "Alles inklappen",
    expandAll: "Alles uitklappen",
  },
  /** A vraag's status icon, read out by a screen reader. */
  status: {
    open: "Nog invullen",
    done: "Ingevuld",
    opmerkingMissing: "Opmerking verplicht",
    optional: "Niet verplicht",
  },
  /** Algemeen vragen carry the VBS field name as their text. */
  algemeen: {
    IsFireContained: "Brand onder controle",
    ResqueExecuted: "Redding uitgevoerd",
    SafeResque: "Redding veilig uitgevoerd",
    Disqualified: "Gediskwalificeerd",
    WorkingTime: "Werktijd",
    SalvageTime: "Redtijd slachtoffer {{number}}",
  },
} as const;
